/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TableRowMessage_EmbedMessage = {
    readonly _id: string;
    readonly createdAt: unknown | null;
    readonly patient: {
        readonly _id: string;
        readonly name: string | null;
    } | null;
    readonly from: string | null;
    readonly to: string | null;
    readonly " $fragmentRefs": FragmentRefs<"TypographyMessageText_EmbedMessage" | "TypographyMessageChannel_EmbedMessage" | "TypographyMessageRef_EmbedMessage" | "IconMessageStatus_EmbedMessage">;
    readonly " $refType": "TableRowMessage_EmbedMessage";
};
export type TableRowMessage_EmbedMessage$data = TableRowMessage_EmbedMessage;
export type TableRowMessage_EmbedMessage$key = {
    readonly " $data"?: TableRowMessage_EmbedMessage$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TableRowMessage_EmbedMessage">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TableRowMessage_EmbedMessage",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "from",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "to",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyMessageText_EmbedMessage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyMessageChannel_EmbedMessage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyMessageRef_EmbedMessage"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IconMessageStatus_EmbedMessage"
    }
  ],
  "type": "Message",
  "abstractKey": null
};
})();
(node as any).hash = 'b991b7303010c3d702adac1ae52a7d01';
export default node;
